import React, { FC } from 'react';
import { WithStyle } from '@ch/common/utils';
import { FormInputFieldProps } from './types';
import { Text } from '@ch/common/components/text';
import { FormInput } from './input';
import { FormError } from '../error';
import { FormInputFieldWrapStyled } from './input.styled';
import { CustomField } from 'react-uforms';
import { FormLabel, LabelProps } from '../label';

export const FormInputFieldLabel = (props: LabelProps) => (
  <FormLabel required={props.required} type={props.type} isError={props.isError}>
    {props.label}
    {props.onRemove && (
      <Text
        as="span"
        $m={[0, 0, 0, 20]}
        $size="sm"
        onClick={props.onRemove}
        $color="grayDarker"
        style={{ cursor: 'pointer' }}
      >
        Remove
      </Text>
    )}
  </FormLabel>
);

export const FormInputField: FC<FormInputFieldProps> & WithStyle = ({
  m,
  mt,
  mr,
  mb,
  ml,
  p,
  pt,
  pr,
  pb,
  pl,
  labelType,
  labelColored,
  onRemove,
  ...props
}) => {
  const labelProps = {
    required: props.required,
    type: labelType,
    label: props.label,
    onRemove,
  };

  return (
    <FormInputFieldWrapStyled {...{ m, mt, mr, mb, ml, p, pt, pr, pb, pl }}>
      <CustomField name={props.name} hideError={true}>
        {({ getErrors }) => {
          const isError = Array.isArray(getErrors()) && getErrors().length > 0;

          return (
            <>
              {props.label && <FormInputFieldLabel isError={labelColored && isError} {...labelProps} />}
              <FormInput {...props} />
              <FormError name={props.name} />
            </>
          );
        }}
      </CustomField>
    </FormInputFieldWrapStyled>
  );
};

FormInputField.defaultProps = {
  $size: 'sm',
  type: 'text',
  disabled: false,
  required: false,
  placeholder: 'Enter',
};

FormInputField.displayName = 'FormInputField';
FormInputField.Style = FormInputFieldWrapStyled;
